/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const sectionLabels = {
    1012: { // CCO
        net_weight: 'Portion Size',
        quality_grade: 'USDA Grade',
        count: 'Treat Count',
        wine_beer_type: 'Wine',
    },
    default: {
        net_weight: 'Portion Size',
        quality_grade: 'USDA Grade',
        count: 'Count',
        wine_beer_type: 'Wine',
    },
};

const optionLabels = {
    default: {
        sparkling_rose: 'Sparkling Rosé',
        rose_wine: 'Rosé Varietal',
        white_wine: 'White Varietal',
        red_wine: 'Red Varietal',
        red_white: 'Red & White',
    },
};

export const getSectionLabels = (brand = '') => {
    if (brand && sectionLabels[brand]) {
        return sectionLabels[brand];
    }
    return sectionLabels?.default || {};
};

export const getOptionLabels = (brand = '') => {
    if (brand && optionLabels[brand]) {
        return optionLabels[brand];
    }
    return optionLabels?.default || {};
};
